import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ModalService} from "../../../../../../shared/modal/modal.service";
import {AriadnextUser} from "../../../api/entity";

@Component({
    selector: 'tfl-bo-create-ariad-applicant-dialog',
    template: `
        <tfl-gentelella-modal-container [id]="user.userId.toString()" [isLarge]="false">
            <tfl-gentelella-modal-header [showDismiss]="false" (dismissHandler)="close()">
                <h5>{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.TITLE' | translate }}</h5>
            </tfl-gentelella-modal-header>

            <tfl-gentelella-modal-body>
                <ng-container *ngIf="user">
                    <div class="row">
                        <div class="col-xs-12">
                            <h5 style="text-align: justify">
                                {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.MODAL_DESCRIPTION' | translate }}
                            </h5>
                        </div>
                    </div>
                    <form>
                        <div class="switch-field">
                            <input type="radio" id="radio-one" name="sendlink_approach" (click)="chooseEmail()" [checked]="!byPhoneChosen"/>
                            <label for="radio-one">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.EMAIL' | translate }}</label>
                            <!-- TODO Remove [disabled] after sms service implementation-->
                            <input type="radio" id="radio-two" name="sendlink_approach" (click)="choosePhone()" [checked]="byPhoneChosen" [disabled]="true"/>
                            <label for="radio-two">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.PHONE' | translate }}</label>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-xs-12" style="text-align: center">
                            <span>{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.SEND_LINK_TO' | translate }}</span>
                            <span *ngIf="byPhoneChosen">{{ user.phoneNumber }}</span>
                            <span *ngIf="!byPhoneChosen">{{ user.email }}</span>
                        </div>
                    </div>
                </ng-container>
            </tfl-gentelella-modal-body>

            <tfl-gentelella-modal-footer [showDefaultButtons]="false">
                <button class="btn btn-sm btn-primary" (click)="start()">
                    {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.START_BUTTON' | translate }}
                </button>
                <button class="btn btn-sm btn-default" (click)="close()">
                    {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.CLOSE_BUTTON' | translate }}
                </button>
            </tfl-gentelella-modal-footer>
        </tfl-gentelella-modal-container>
    `
})
export class CreateApplicantDialogComponent {

    @Output("onStart") onStartsHandler: EventEmitter<boolean> = new EventEmitter();
    @Input("user") user: AriadnextUser;

    byPhoneChosen: boolean = false;

    constructor(private _modalService: ModalService) {
    }

    chooseEmail() {
        this.byPhoneChosen = false;
    }

    choosePhone() {
        this.byPhoneChosen = true;
    }

    show() {
        this._modalService.open(this.user.userId.toString());
    }

    close() {
        this._modalService.close(this.user.userId.toString());
    }

    start() {
        this.close();
        this.onStartsHandler.emit(this.byPhoneChosen);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/result/create-applicant.dialog.component.ts